import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  currentStep: number;
  textArray: string[];
};

export const DotStepIndicator: FC<Props> = ({ currentStep, textArray }) => {
  return (
    <>
      <div className={styles.chartWrapper}>
        {textArray.map((label, index) => {
          const stepNumber = index + 1;
          let stateClass = "";
          if (stepNumber < currentStep) {
            stateClass = styles.prev;
          } else if (stepNumber === currentStep) {
            stateClass = styles.current;
          }
          return (
            <span
              key={label}
              className={[styles.chartItem, stateClass].filter(Boolean).join(" ")}
            />
          );
        })}
      </div>
      <div className={styles.stepContents}>
        <div className={styles.stepProgress}>
          <span className={styles.stepCurrent}>{currentStep}</span>
          <span className={styles.stepMax}>/{textArray.length}</span>
        </div>
        <p className={styles.stepText}>{textArray[currentStep - 1]}</p>
      </div>
    </>
  );
};
